import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=68cba952&scoped=true"
import script from "./DepartmentList.vue?vue&type=script&lang=js"
export * from "./DepartmentList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&id=68cba952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cba952",
  null
  
)

export default component.exports